module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/cloud-infor-phone1.5ee44c49.png";